import React from 'react';
import RelayService from '../service/RelayService';
import { QueryRenderer, graphql } from 'react-relay';
import WebIntlProvider from '../ui/i18n/WebIntlProvider';
import SellerShippingPrice from './SellerShippingPrice';

export default class SellerShippingPriceLoader extends React.Component {

  render() {
    console.log('@loader', this.props);
    return (
        <QueryRenderer
          environment={RelayService.environment}
          query={graphql`
            query SellerShippingPriceLoaderQuery($sellerContactId: String, $overseas: Boolean) {
                calculateSellerShippingPrice {
                    ...SellerShippingPrice_sellerShippingPriceResponseData @arguments(sellerContactId: $sellerContactId, overseas: $overseas)
                }
            }
          `}
          variables={{
            sellerContactId: this.props.sellerContactId,
            overseas: (this.props.overseas =="true")
          }}
          render={({ error, props }) => {
              // render results from query
              if (error) {
                // console.log('rendering @loader with error', error)
                return <div>{error.message}</div>;
              } else if (props) {
                // console.log('rendering @loader with props', props)
                return (
                  <WebIntlProvider>
                    <SellerShippingPrice sellerContactId={this.props.sellerContactId} overseas={this.props.overseas} sellerShippingPriceResponseData={props.calculateSellerShippingPrice} />
                  </WebIntlProvider>
                )
              }
              return <div>Loading</div>
            }
          }
        >
        </QueryRenderer>
    )
  }
}
